/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue'
import axios from 'axios'
import $ from 'jquery'
import Isotope from 'isotope-layout'
import vmodal from 'vue-js-modal'

import store from './store'

Vue.prototype.$http = axios
Vue.use(vmodal)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store
});

$(function() {
  // Sticky Header / Nav
  $(window).on('scroll', function() {
    pinHeader();
  });
  pinHeader();

  function pinHeader() {
    var sticky = $('header'),
        scroll = $(window).scrollTop(),
        hero = $('#hero').outerHeight() || 0;

    if (scroll >= hero) {
      sticky.addClass('fixed').next().css('margin-top', sticky.outerHeight());
    } else {
      sticky.removeClass('fixed').next().attr('style', '');
    }
  }

  // Isotope
  var heads = document.querySelector('.headshots');
  if (heads) {
    var headsIso = new Isotope(heads, {
        itemSelector: '.headshot',
        percentPosition: true
    });
  }
  var checklists = document.querySelector('.checklists');
  if (checklists) {
    var checklistsIso = new Isotope(checklists, {
        itemSelector: '.checklist'
    });
  }

  // Accordion
  $('.toggle .toggle-title').on('click', function() {
      if (! $(this).closest('.toggle').hasClass('active')) {
          $('.toggle.active').removeClass('active').find('.toggle-inner').slideUp(200);
      }

      $(this).closest('.toggle').toggleClass('active').find('.toggle-inner').slideToggle(200);
  });
});
